import { useGoogleLogin } from "@react-oauth/google";
import { Button, Form, Image, Input, Modal } from "antd";
import GoogleLogo from "assets/images/google.logo.svg";
import axios from "axios";
import UserVerificationModal from "features/register/userVerificationModal";
import User from "models/user/user";
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { downloadEvent, redirectToUrl } from "./generalUtility";
import { phoneRegex } from "./regexUtilities";
import { useQueryClient } from "@tanstack/react-query";
import { trackPromise } from "react-promise-tracker";

export default function GoogleLogin({ form }) {
  const [googleToken, setGoogleToken] = useState();
  const [showModal, setShowModal] = useState(false);

  const history = useNavigate();
  const dispatch = useDispatch();
  const [form1] = Form.useForm();
  const roleTypeValue = useRef();
  const email = useRef();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);

  const [btnLoading, setBtnLoading] = useState(false);
  useEffect(() => {
    googleToken && getUserInfo();
  }, [googleToken]);

  const handleOk = () => {
    setShowModal(false);
  };
  const handleCancel = () => {
    setShowModal(false);
  };
  const getUserInfo = async (values) => {
    const userInfo = await trackPromise(
      axios.get(
        `https://people.googleapis.com/v1/people/me?personFields=names,emailAddresses,genders`,

        {
          headers: { Authorization: `Bearer ${googleToken}` },
          "content-type": "application/json",
        }
      )
    );
    const DataValues = {
      roleType: 2,
      firstName: userInfo?.data?.names[0]?.givenName,
      lastName: userInfo?.data?.names[0]?.familyName,
      email: userInfo?.data?.emailAddresses[0]?.value,
      gender: userInfo?.data?.genders
        ? userInfo?.data?.genders[0]?.value
        : null,
      // phoneNumber: values?.phoneNumber,
    };

    try {
      setBtnLoading(true);
      await dispatch(User.loginWithGoogle(DataValues));
      setBtnLoading(false);
      redirectToUrl(
        "/journal-request",
        queryParams.get("diaryId"),
        queryParams.get("diaryTopicId")
      );
    } catch (error) {
      email.current = userInfo?.data?.emailAddresses[0].value;
      error?.statusCode === 403 &&
        error.error.data.data.isEmailConfirmed === "False" &&
        setShowModal(true);
      setBtnLoading(false);
    }
    return userInfo;
  };
  const fieldsValidation = async () => {
    try {
      const res = await form.validateFields(["roleType"]);
      roleTypeValue.current = res?.roleType;
      login();
      downloadEvent("GoogleLogin");
    } catch (error) {}
  };

  const login = useGoogleLogin({
    onSuccess: (codeResponse) => {
      setGoogleToken(codeResponse.access_token);
    },
    onError: (error) => {},
  });

  return (
    <>
      <Form.Item className="mb-0">
        <Button
          block
          className="google-account-btn"
          size="large"
          onClick={fieldsValidation}
          icon={<Image preview={false} src={GoogleLogo} alt="" />}
        >
          Continue with Google Account
        </Button>
      </Form.Item>
      <UserVerificationModal
        isModalOpen={showModal}
        setIsModalOpen={setShowModal}
        email={email?.current}
      />
      {/* <Modal
        className="create-diary-modal cm-modal "
        centered
        open={showModal}
        onOk={handleOk}
        onCancel={handleCancel}
        closeIcon={<i className="icon-close"></i>}
        footer={[
          <Button
            form="myForm"
            key="submit"
            type="primary"
            loading={btnLoading}
            onClick={form1.submit}
          >
            Submit
          </Button>,
        ]}
      >
        <Form id="myForm" onFinish={getUserInfo} form={form1}>
          <Form.Item
            name="phoneNumber"
            rules={[
              {
                required: true,
                message: "Please enter phone number",
              },
              {
                whitespace: true,
                message: "Only Spaces are not allowed",
              },
              {
                pattern: new RegExp(phoneRegex),
                message: "Please Enter Valid Phone Number",
              },
            ]}
          >
            <Input
              type="phone"
              suffix={<i className="icon-phone site-form-item-icon"></i>}
              placeholder="phone number"
              size="large"
            />
          </Form.Item>
        </Form>
      </Modal> */}
    </>
  );
}
